import React, { Component, useEffect, useState } from 'react'

import { makeStyles } from '@material-ui/core/styles'

import { connect } from 'react-redux'
import { postEnrollmentsData, getSISStatus } from '../../actions'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'

import { getSISImportStatus, sendEmail } from '../../services/saga'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  }
}))

let enrollmentCSV = []

const EnrollmentsProcess = (props) => {
  const { data, postEnrollmentsData } = props

  const [progress, setProgress] = useState(10)
  const [sisImportID, setSisImportID] = useState(0)
  const [scvErrors, setCsvErrors] = useState([])
  const [errorAttachment, setErrorAttachment] = useState('')
  const [importedItemCounts, setImportedItemCounts] = useState(0)

  const [textStatus, setTextStatus] = useState('Processing,Please wait..')

  const enrollmentCSV = []

  const completed = ''

  useEffect(() => {
    // const { data } = this.props;

    enrollmentCSV.push(['course_id', 'user_id', 'role_id', 'status'])

    let role = data.summery.data.filter((data) => data.value == 'role')

    let csvStatus = data.csvActionType

    for (let i = 0; i < data.users.data.length; i++) {
      let loopUser = data.users.data[i][0]

      for (let k = 0; k < data.summery.courses.length; k++) {
        let loopCourse = data.summery.courses[k]

        enrollmentCSV.push([
          loopCourse.sis_course_id,
          loopUser.sis_user_id,
          role[0].id,
          csvStatus
        ])
      }
    }

    postEnrollmentsData(enrollmentCSV)

    let allUserList = data.summery.userstext.split(',')
    let confirmedUserList = data.users.data.map((user) => user[0]['login_id'])
    let usersNotFound = allUserList.filter(
      (data) => !confirmedUserList.includes(data)
    )

    // commented for future use
    //sendEmail('users_not_found', { users: usersNotFound });
  }, [])

  useEffect(() => {
    const interval = setInterval(async () => {
      if (data.sis_status.id && progress !== 100 && progress !== 0) {
        const sisStatus = await getSISImportStatus(data.sis_status.id)

        let textStatus = ''
        let completed = 0
        let sis_counts = []

        if (sisStatus.workflow_state == 'created') {
          textStatus = 'The request has been created.'
          completed = 40
        }

        if (sisStatus.workflow_state == 'importing') {
          textStatus = 'The request is currently processing.'
          completed = 70
        }

        if (sisStatus.workflow_state == 'imported') {
          textStatus = 'The request has completed successfully.'
          completed = 100
          sis_counts = sisStatus.data.counts
        }

        if (sisStatus.workflow_state == 'imported_with_messages') {
          textStatus = 'CSV error'
          completed = 0
          setCsvErrors(sisStatus.processing_warnings)
          setErrorAttachment(sisStatus.errors_attachment.url)
        }

        setProgress(completed)
        setTextStatus(textStatus)
        setImportedItemCounts(sis_counts)
      }
    }, 2000)
    return () => clearInterval(interval)
  }, [data.sis_status, sisImportID, progress])

  return (
    <React.Fragment>
      <Typography variant='subtitle1'>{textStatus}</Typography>

      <LinearProgress variant='determinate' value={progress} />

      {progress == 100 ? (
        <ul>
          <li>
            Imported Items
            <ul>
              <li>Enrolments: {importedItemCounts['enrollments']}</li>
            </ul>
          </li>
        </ul>
      ) : null}

      {completed == 100 ? (
        <div>
          {' '}
          <Button
            style={{
              marginTop: '30px',
              marginBottom: '30px'
            }}
            variant='outlined'
            size='large'
            color='primary'
            onClick={() => window.location.reload(false)}
          >
            Back to Home
          </Button>{' '}
        </div>
      ) : (
        ''
      )}

      {completed == 0 ? (
        <div>
          {' '}
          <Button
            style={{
              marginTop: '30px',
              marginBottom: '30px'
            }}
            variant='outlined'
            size='large'
            color='primary'
            onClick={() => window.location.reload(false)}
          >
            Back to Home
          </Button>{' '}
        </div>
      ) : (
        ''
      )}
    </React.Fragment>
  )
}

function mapStateToProps(state) {
  return {
    data: state.CourseLevelAdmin
  }
}

export default connect(mapStateToProps, { postEnrollmentsData, getSISStatus })(
  EnrollmentsProcess
)
